export default "__VITE_ASSET__DnbJ_v55__"